import { Typography, useMediaQuery } from '@material-ui/core'
import useStyles from './styles'

const HeroCopy = () => {
  const classes = useStyles()
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('xs'))

  return (
    <span className={classes.centerTextOnMobile}>
      <Typography component="h1" variant="h4">
        Order your pump <br /> through insurance!
      </Typography>
      <Typography component="h2" variant="body1">
        We'll take care of contacting your provider {isMobile && <br />} and
        billing your insurance.
      </Typography>
    </span>
  )
}

export default HeroCopy
